import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardBody, Container } from 'reactstrap';
import { AuthProtected } from '../Routes/AuthProtected';
import Footer from './Footer';
import Header from './Header';
import LayeredNavigation from './LayeredNavigation/LayeredNavigation';
import { useSelector, useDispatch } from 'react-redux';
import {
  getOrganizationTree,
  getCountries,
  getOrganizations,
  getBrands,
  getStores,
} from '../actions/organization/index';
import { getCampaignTypes } from '../actions/campaignType';

import { getAnalyticsPages } from '../actions/analytics';

const Layouts = ({ children }) => {
  const [theme, setTheme] = useState('light');
  const location = useLocation();
  const dispatch = useDispatch();
  const { userPermissions, user } = useSelector((state) => state?.user || {});

  const {
    organizationTree,
    countries,
    isRefreshCountry,
    isRefreshOrganizationTree,
    isRefreshOrganizations,
    isRefreshBrands,
    campaignTypes,
  } = useSelector((state) => state?.organization);

  const { isRefreshAnalyticsPages, analyticsPages } = useSelector(
    (state) => state?.analytics
  );

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
  }, [theme]);

  useEffect(() => {
    fetchCampaignTypes();
  }, [user, userPermissions]);

  useEffect(() => {
    if (isRefreshOrganizationTree) {
      getOrganizationTreeFunc();
    }
  }, [isRefreshOrganizationTree]);

  useEffect(() => {
    if (isRefreshCountry) {
      getCountriesFunc();
    }
  }, [isRefreshCountry]);

  useEffect(() => {
    if (isRefreshOrganizations) {
      getOrganizationsFunc();
    }
  }, [isRefreshOrganizations]);

  useEffect(() => {
    if (isRefreshBrands) {
      getBrandsFunc();
      getStoresFunc();
    }
  }, [isRefreshBrands]);

  useEffect(() => {
    if (isRefreshAnalyticsPages) {
      getAnalyticsPagesFunc();
    }
  }, [isRefreshAnalyticsPages]);

  const getOrganizationTreeFunc = async () => {
    try {
      await getOrganizationTree(
        { input: { organizationId: user?.organizationId || 'DANUBE_GROUP' } },
        dispatch
      );
    } catch (e) {
      console.log(e);
    }
  };

  const getCountriesFunc = async () => {
    try {
      const data = { input: {} };
      await getCountries(data, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const getStoresFunc = async () => {
    try {
      const data = { input: {} };
      await getStores(data, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const getOrganizationsFunc = async () => {
    try {
      await getOrganizations({ input: {} }, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const getBrandsFunc = async () => {
    try {
      const data = { input: {} };
      await getBrands(data, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const getAnalyticsPagesFunc = async () => {
    try {
      const data = { input: {} };
      await getAnalyticsPages(data, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchCampaignTypes = async () => {
    try {
      const hasPermission =
        userPermissions?.includes('manage_all') ||
        userPermissions?.includes('manage_promotion') ||
        userPermissions?.includes('view_promotion') ||
        userPermissions?.includes('list_promotion') ||
        userPermissions?.includes('delete_promotion');
      if (hasPermission) {
        await getCampaignTypes(dispatch);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // Check if the current URL matches the condition to exclude the "d-grid" class
  const isProfilePage = location.pathname === '/customers/profile';
  const isWalletTransactionDetails =
    location.pathname === '/wallet/ahlan/transaction/details';
  const isPromotionsTransactionDetails =
    location.pathname === '/promotions/danube-home/transaction/details';
  const isPromotionCreate =
    location.pathname === '/promotions/danube-home/promotions/create';
  const isGiftCardCreate =
    location.pathname === '/gift-card/ahlan-gift-card/create';
  const isPromotionsDetail =
    location.pathname.indexOf('/promotions/detail') > -1;
  const isCustomerDetail = location.pathname.indexOf('/members/profile') > -1;
  return (
    <AuthProtected>
      <div id="layout-wrapper" className="min-vh-100 d-flex flex-column">
        <Header theme={theme} />

        <Container fluid>
          <Card className="rounded-4 m-0">
            <CardBody className="p-0">
              <div
                className={`main-content ${
                  isProfilePage ||
                  isWalletTransactionDetails ||
                  isPromotionsTransactionDetails ||
                  isPromotionCreate ||
                  isGiftCardCreate ||
                  isPromotionsDetail ||
                  isCustomerDetail
                    ? ''
                    : 'd-grid'
                }`}
              >
                {/* Render LayeredNavigation only if NOT profile or wallet list details page */}
                {!(
                  isProfilePage ||
                  isWalletTransactionDetails ||
                  isPromotionsTransactionDetails ||
                  isPromotionCreate ||
                  isGiftCardCreate ||
                  isPromotionsDetail ||
                  isCustomerDetail
                ) && <LayeredNavigation />}
                {children}
              </div>
            </CardBody>
          </Card>
        </Container>

        <Footer theme={theme} toggleTheme={toggleTheme} />
      </div>
    </AuthProtected>
  );
};

export default Layouts;
